'use client';

import { useQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';

import { GET_EVM_NFTS_BY_OWNERS } from '@repo/api-core-toolkit';
import { EVMNft, EvmNFTCollectionContractName } from '@repo/types-client';

export interface UseEvmNftsIndexerProps {
  addresses?: string[];
  collections?: EvmNFTCollectionContractName[];
}

export const useEvmNftsIndexer = <T extends UseEvmNftsIndexerProps>(
  props: T,
): ReturnType<typeof useQuery<EVMNft[], UseEvmNftsIndexerProps>> => {
  return useQuery<EVMNft[], UseEvmNftsIndexerProps>(
    GET_EVM_NFTS_BY_OWNERS as unknown as DocumentNode,
    {
      variables: {
        addresses: props.addresses,
        collections: props.collections,
      },
      skip: !props.addresses?.length || !props.collections?.length,
      fetchPolicy: 'network-only',
    },
  );
};
